import { z } from 'zod';

const orgIdSchema = z.enum(['interact', 'data']);
export type ORG_ID = z.infer<typeof orgIdSchema>;

/**
 * Parses the router `detailType` param into the org detail page's tab id. The
 * visual switcher now lives in the shared, pure `OrgSwitcherPure`
 * (@poseidon/components/OrgDetail); this stays app-side because it maps the URL.
 */
export const convertStringToOrgID = (s: string | undefined, defaultId: ORG_ID): ORG_ID =>
  orgIdSchema.default(defaultId).catch(defaultId).parse(s);
